module.exports = __webpack_public_path__ + "img/pirates.079365e3.svg";